import React, { Component } from "react";

export default class index extends Component {
  render() {
    return (
      <h1 className="fs-1 text-center" style={{ paddingTop: "50px" }}>
        Pré-treinos
      </h1>
    );
  }
}
